<template>
  <div class="df both-side">
    <div class="tree-layout">
      <department-menu
        @handleSelectUserList="handleSelectUserList"
        :expandedKeys="expandedKeys"
        ref="departmentMenuRef"
      ></department-menu>
    </div>

    <staff :userList="userList" @updateTable="updateTable"></staff>
  </div>
</template>

<script>
import { defineComponent, reactive, provide, ref, inject, watch } from "vue";
import { getStructure } from "@/request/view/personal";
import departmentMenu from "@/views/personnelManagement/component/departmentMenu/index.vue";
import staff from "@/views/personnelManagement/component/staff/staff.vue";

export default defineComponent({
  components: { departmentMenu, staff },
  setup() {
    const structureData = reactive([]);
    provide("structureData", structureData);

    const userList = reactive([]);

    const expandedKeys = reactive([]);

    const departmentMenuRef = ref();

    const handleSelectUserList = (list) => {
      userList.length = 0;
      userList.push(...list);
    };

    const getExpandKey = (list) => {
      expandedKeys.length = 0;
      const ite = (treeList) => {
        treeList.forEach((item) => {
          if (item.children && item.children.length > 0) {
            expandedKeys.push(item.id);
            ite(item.children);
          }
        });
      };
      ite(list);
    };

    const getData = () => {
      getStructure().then((res) => {
        structureData.length = 0;
        if (res.code === 200 && res.data) {
          structureData.push(...res.data);
          getExpandKey(res.data);
        }
      });
    };

    const updateTable = () => {
      getStructure().then((res) => {
        structureData.length = 0;
        if (res.code === 200 && res.data) {
          structureData.push(...res.data);
          departmentMenuRef.value.refreshData();
        }
      });
    };

    const tabActivekey = inject("tabActivekey", null);

    watch(
      () => tabActivekey,
      (val) => {
        if (val && val.value === "人员管理") {
          getData();
        }
      },
      {
        immediate: true,
        deep: true,
      }
    );

    return {
      userList,
      expandedKeys,
      departmentMenuRef,
      updateTable,
      handleSelectUserList,
    };
  },
});
</script>

<style lang="less" scoped>
.tree-layout {
  height: calc(100vh - 200px);
  overflow-y: scroll;
  padding-right: 20px;
}
</style>
